import { Component, OnInit } from '@angular/core';
import { slideInOutAnimation } from 'src/app/services/slide-io.animation';
import { RegisterTesting } from 'src/app/stores/enrollment/registerTesting.store';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GENDERS, DISPLAY_STATUS_OBJECT, STATUS_OBJECT } from 'src/app/dummy/status';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { IRegisterTesting } from 'src/app/interfaces/enrollment';
import { ConvertService } from 'src/app/services/convert.service';
import { DataService } from 'src/app/services/data.service';
import { MatSnackBar } from '@angular/material';
import { ConfigStore } from 'src/app/stores/config.store';

@Component({
  selector: 'app-register-test-form',
  templateUrl: './register-test-form.component.html',
  styleUrls: ['./register-test-form.component.scss'],
  host: { "[@slideInOutAnimation]": "" },
  animations: [slideInOutAnimation],
})
export class RegisterTestFormComponent implements OnInit {
  form: FormGroup;
  GENDER_LIST = GENDERS;
  processClose: boolean = false;
  ITEM: any;
  PROGRAM_LIST: any;

  TERM: any;
  constructor(public store: RegisterTesting,
    private router: Router,
    private book: BookstoreStore,
    private auth: AuthStore,
    private ds: DataService,
    private snackBar: MatSnackBar,
    public config: ConfigStore,
    private fb: FormBuilder) { }

  async ngOnInit() {
    this.form = this.fb.group({
      lastName: [null, Validators.required],
      firstName: [null, Validators.required],
      phone: [null, Validators.required],
      gender: [this.GENDER_LIST[0], Validators.required],
      description: [null],
      dateOfBirth: [new Date(), Validators.required],
      program: [null, Validators.required],
      englishName: [null, Validators.required]
    })
    this.PROGRAM_LIST = await this.book.fetchListArray('general_placement_test', "name");
    this.form.patchValue({
      program: this.PROGRAM_LIST[0]
    })
    this.TERM = await this.config.fetchTerm();
  }

  compareWithObj(a: any, b: any): boolean {
    if (b) return a.key === b.key;
  }

  displayItem(item: any): string {
    return item ? item.name : item;
  }


  create(f: any) {
    if(!this.TERM){
      alert("Invalid active term!")
      return;
    }
    if (this.form.valid && this.TERM) {
      this.processClose = true;
      const { lastName, firstName, gender, phone, description, program, dateOfBirth, englishName } = f;
      const { user, selectedCompanyKey } = this.auth;
      const registerStatus = STATUS_OBJECT.submitted;
      const key = this.ITEM ? this.ITEM.key : this.ds.createId();
      const item: IRegisterTesting = {
        key: key,
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: this.ITEM ? this.ITEM.created_at : new Date(),
        created_by: this.ITEM ? this.ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
        page_key: ConvertService.pageKey(),
        keyword: ConvertService.toCapitalize(`${lastName.trim()}${firstName.trim()}`),
        organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
        organizationKey: selectedCompanyKey,
        created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        studentKey:key,
        studentRef:this.ds.studentRef().doc(key).ref,
        lastName: ConvertService.toCapitalize(lastName),
        firstName: ConvertService.toCapitalize(firstName),
        fullName: ConvertService.toCapitalize(firstName + ' ' + lastName),
        description: description,
        phone: phone,
        gender: gender,
        englishName,
        dateOfBirth,
        classData: program,
        classKey: program.key,
        classRef: this.ds.generalPlacementTestRef().doc(program.key).ref,
        termKey:this.TERM.key,
        termRef:this.ds.termRef().doc(this.TERM.key).ref,
      }
      this.store.save(item, (success, res) => {
        if (success) {
          this.snackBar.open("Register testing has been saved successful.", "Done", { duration: 2500 });
        }
        this.form.enable();
        this.form.reset();
        this.form.patchValue({
          dateOfBirth,
          gender,
          program,
        })
        this.processClose = false;
        this.router.navigate([`/enrollment/register-test/form/draft`])
      })

    }
  }

  _goBack() {
    this.router.navigate([`/enrollment/register-test`])
  }

  resetForm() {
    this.form.reset();
  }

}
